module.exports = __webpack_public_path__ + "static/img/created_order.a4802fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/created_order.png
// module id = ZcKY
// module chunks = 3